import { Button } from './Button';
export { Button };
export default Button;
//# sourceMappingURL=index.js.map